export const customColor = {
  black1: '#191a22',
  black2: '#292a35',
  blue1: '#00a2df',
  blue2: '#0069a4',
  gray1: '#525365',
} as const
